export const ACCESS_TOKEN = "access_token";
export const JWT_TOKEN = "jwt_token";
const APP_NAME = "menta-server";
export const CAPITALIZED_APP =
  APP_NAME[0].toUpperCase() + APP_NAME.slice(1).toLowerCase();
